import { Grid, Tooltip, Typography } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";
import React from "react";

const Heading: React.FC<{
  filters: string[],
  name: string,
  text: string,
  tooltip?: string,
}> = (props) => {
  if (!props.filters.includes(props.name)) return null;
  if (props.tooltip) {
    return (
      <Grid size={{ xs: 12 }}>
        <Tooltip title={props.tooltip}>
          <Typography component="h4" variant="subtitle2" style={{ marginBottom: 2, marginTop: 25, fontSize: 14, display: "flex", alignItems: "center", gap: 4 }}>
            {props.text} <InfoIcon fontSize="inherit" />
          </Typography>
        </Tooltip>
      </Grid>
    );
  }
  return (
    <Grid size={{ xs: 12 }}>
      <Typography component="h4" variant="subtitle2" style={{ marginBottom: 2, marginTop: 25, fontSize: 14 }}>
        {props.text}
      </Typography>
    </Grid>
  );
};

export default Heading;
